export const useStyles = theme => ({
  gridContainer: {
    alignItems: 'center',
  },
  button: {
    backgroundColor: '#009F3C',
    borderColor: '#009F3C',
    fontSize: '13px',
    textTransform: 'uppercase',
    marginLeft: '20px',
    letterSpacing: 'unset',
    minWidth: 'unset',
    color: '#fff',
  },
});
